import { InputLabel, Stack, Typography, Box } from '@mui/material';
import Label from './Label';

export default function KeyValuesDisplay({ title, data, variant = 'ghost', color = 'info' }) {
  return (
    <Stack>
      <InputLabel shrink>{title}</InputLabel>
      <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
        {data?.length ? (
          data.map((value, index) => (
            <Label variant={variant} color={color} key={index}>
              <Box sx={{ overflowX: 'auto', whiteSpace: 'nowrap', width: '100%', maxWidth:400, display: 'block'}}>
                <Typography fontFamily="monospace">{value}</Typography>
              </Box>
            </Label>
          ))
        ) : (
          <Typography variant="body1" gutterBottom>
            -
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
